export enum Collection{
    Branches = 'Branches', 
    Companies = 'Companies',
    Users = 'Users',
    Reviews = "Reviews",
    CompanyRoles = "CompanyRoles",
    QuestionPaper = 'QuestionPaper',
    fbanswer = "fbanswer"
}